import React, {useState, useEffect} from "react";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";

import DcaModal from "./DcaModal";
import RemoveModal from "components/common/modals/RemoveModal";
import SingleDcaRow from "./SingleDcaRow";
import dcaSettingsService from "services/dashboard-stats-service";
// Assets
import chartImg from "../../assets/images/chart-line-in-circle.png";
import chartImgSmall from "../../assets/images/chart-line-in-circle-small.png";
import "./DcaPage.css";
import Header from "components/common/tablePages/Header";
import axios from "axiosConfig";
import {sortFunc} from "utils/helpers";
import {iconBucket} from "utils/constants";
// Sort options - value = property name from api; name = what user sees; type = type of value
const sortOptions = [
  {value: "on_off", name: "ON/OFF", type: "boolean", ascending: true},
  {value: "ticker", name: "Ticker", type: "string", ascending: true},
  {value: "created_at", name: "Date Added", type: "date", ascending: true},
  {value: "max_amount", name: "Amount", type: "number", ascending: true},
];

// 'Ticker, On/Off, Date added, amount'
const DcaPage = () => {
  const [sortBy, setSortBy] = useState(sortOptions[0]);
  const [isDcaModal, setIsDcaModal] = useState(false);
  const [isRemoveDcaModal, setIsRemoveDcaModal] = useState(false);
  const [isShowEditModal, setIsShowEditModal] = useState(false);
  const [input, setInput] = useState("");
  const [dcaData, setDcaData] = useState([]);
  const [selectedDca, setSelectedDca] = useState({});
  const [showData, setShowData] = useState([]);

  useEffect(() => {
    // ...

    const fetchData = async () => {
      try {
        const dcaSettings = await dcaSettingsService.getDCAsettings("/");
        const dcaSettingsWithLogo = dcaSettings.map(dca => ({
          ...dca,
          logo: (
            <div className="logo-container border border-0">
              {" "}
              <img
                src={`${iconBucket}${dca.ticker?.toLowerCase()}.png`}
                onError={e => (e.target.src = `${iconBucket}default_stock.png`)}
                alt="Logo"
                width="32"
                height="32"
              />
            </div>
          ),
        }));
        setDcaData(dcaSettingsWithLogo);
      } catch (error) {
        console.log("Error fetching dcaSettings:", error);
      }
    };

    fetchData();

    // ...
  }, []);

  useEffect(() => {
    const filteredData = dcaData.filter(dca => {
      // filter brokers by the `search` first. if `search` variable
      // is empty - by default - then all brokers will be displayed

      const name = dca.name?.toLowerCase();
      const ticker = dca.ticker?.toLowerCase();
      const search = input.toLowerCase();
      if (
        (name && name.includes(search)) ||
        (ticker && ticker.includes(search))
      )
        return dca;
    });

    // Sort data
    const sortedData = sortFunc({data: filteredData, ...sortBy});
    setShowData(sortedData);
  }, [input, dcaData, sortBy]);
  const handleSearch = e => {
    const value = e.target.value;
    setInput(value);
  };

  const handleDelete = async () => {
    try {
      const res = await axios.delete(`api/dcasetting/${selectedDca.id}/`);
      console.log(res);

      setDcaData(prev => {
        const newDca = [...prev];
        const index = newDca.indexOf(selectedDca);

        newDca.splice(index, 1);
        return newDca;
      });
      setIsRemoveDcaModal(false);
    } catch (error) {
      console.log("Error removing dca: " + error.message);
    }
  };

  const onSortClick = e => {
    // Find the sort option
    const sortOption = sortOptions.find(option => option.value === e);
    if (sortOption.value === sortBy.value)
      setSortBy(prev => ({...prev, ascending: !prev.ascending}));
    else {
      setSortBy(sortOption);
    }
    console.log("sortBy", sortBy);
    console.log("sortOption", sortOption);
  };

  // Each function triggers modal opening
  const showAddDcaModal = () => {
    setIsDcaModal(true);
    setIsShowEditModal(false);
  };
  const showEditDcaModal = () => {
    setIsDcaModal(true);
    setIsShowEditModal(true);
  };
  const showRemoveDcaModal = () => {
    setIsRemoveDcaModal(true);
  };

  return (
    <section id="brokers-section" className="mb-0">
      <Header
        title="Your SMART DCA instructions"
        titleEmpty="Add your first SMART DCA"
        text="Smart automation for your investments"
        btnText="Add SMART DCA"
        imgBig={chartImg}
        imgSmall={chartImgSmall}
        isEmpty={dcaData.length === 0 ? true : false}
        setIsModal={setIsDcaModal}
      />
      <div
        className={
          dcaData.length === 0 ? "brokers-table d-none" : "brokers-table"
        }
      >
        <Container
          className={`mt-5  ${
            dcaData.length === 0 ? "d-none" : "d-block d-lg-block"
          }`}
        >
          <Row>
            <Col className="d-block d-lg-flex p-0 justify-content-between gap-3 mb-4">
              <Col className="d-block d-lg-flex p-0 justify-content-start gap-3 col-lg-6  ">
                <InputGroup
                  size="sm"
                  className="dark-input mb-3 mb-lg-auto w-auto"
                >
                  <InputGroup.Text id="search-input-label">
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    id="search-input"
                    aria-label="search"
                    aria-describedby="search-input-label"
                    placeholder="Search Now"
                    name="Search"
                    value={input}
                    onChange={handleSearch}
                  />
                </InputGroup>
                <DropdownButton
                  className="sort-dropdown mb-3 mb-lg-auto"
                  id="sort"
                  name="sort"
                  value={sortBy}
                  onSelect={onSortClick}
                  title="Sort By"
                  variant="sort"
                >
                  {sortOptions.map((option, i) => (
                    <Dropdown.Item
                      className="p-3"
                      eventKey={option.value}
                      active={option.value === sortBy.value}
                      key={i}
                    >
                      {option.name}
                      {option.value === sortBy.value ? (
                        sortBy.ascending ? (
                          <i class="bi bi-arrow-down-short"></i>
                        ) : (
                          <i class="bi bi-arrow-up-short"></i>
                        )
                      ) : (
                        <i class="bi bi-arrow-down-short"></i>
                      )}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
              <Col className="d-lg-flex p-0 justify-content-end">
                <button
                  className="btn btn-primary text-md btn-block btn-full full-width-sm"
                  onClick={showAddDcaModal}
                >
                  <i className="bi bi-plus"></i> Add DCA
                </button>
              </Col>
            </Col>
          </Row>
        </Container>
        <Container>
          {/* Table */}
          <Row>
            {/* Controllers */}

            {/* Table header */}
            <Col className="d-none d-lg-flex justify-content-between lighter-section  px-4 ps-xl-2 pe-xl-5 py-3 mb-3">
              <Col sm={1} xl={2} className="me-3">
                Ticker
              </Col>
              <Col
                sm={9}
                className="d-flex justify-content-between align-content-center"
              >
                <Col sm={2}>Last Close</Col>
                <Col sm={2}>Percent Down</Col>
                <Col sm={2}>Qty./Order</Col>
                <Col sm={2}>Max.Amount</Col>

                <Col sm={2}>Date Added</Col>

                <Col sm={2}>Broker</Col>
              </Col>
              <Col
                sm={2}
                xl={1}
                className="d-flex justify-content-between align-content-center"
              >
                <Col sm={6} xl="auto" className="me-xl-1">
                  Off/On
                </Col>
                <Col
                  sm={6}
                  xl="auto"
                  className="d-flex justify-content-center justify-content-xl-end ms-xl-3"
                >
                  Action
                </Col>
              </Col>
            </Col>
          </Row>
          {/* Table child rows */}
          {showData.map(dca => (
            <SingleDcaRow
              dcaData={dca}
              setData={setDcaData}
              showModal={showEditDcaModal}
              showRemoveModal={showRemoveDcaModal}
              setSelected={setSelectedDca}
              key={dca.id}
            />
          ))}
        </Container>
      </div>
      {/* Modals */}
      {isDcaModal && (
        <DcaModal
          show={isDcaModal}
          setShow={setIsDcaModal}
          setDcaData={setDcaData}
          isShowEditModal={isShowEditModal}
          dcaData={isShowEditModal ? selectedDca : {}}
        />
      )}
      <RemoveModal
        show={isRemoveDcaModal}
        setShow={setIsRemoveDcaModal}
        handleClick={handleDelete}
        header="Are you sure you want to Delete 
        this SMART DCA instruction?"
      />
    </section>
  );
};
export default DcaPage;
